import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Exchange code for session
        const { data: { session }, error } = await supabase?.auth?.getSession();
        
        if (error) {
          console.error('Error getting session:', error);
          navigate('/?error=verification_failed');
          return;
        }

        if (session) {
          // User is verified and logged in
          navigate('/financial-dashboard-overview');
        } else {
          // No session found, redirect to login
          navigate('/?message=please_login');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/?error=unexpected_error');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-4" />
        <p className="text-foreground text-lg font-medium">Verificando seu e-mail...</p>
        <p className="text-muted-foreground text-sm mt-2">Aguarde enquanto finalizamos seu login.</p>
      </div>
    </div>
  );
};

export default AuthCallback;